export default "__VITE_ASSET__WDEm63nh__"